import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import EvidenceForm from '../Forms/EvidenceForm';

const AddEditEvidenceModal = ({
	dataActivity,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				Actividad
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '1' })}
							onClick={() => {
								toggleTab('1');
							}}
						>
							Información General
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							href='#'
							className={classnames({ active: activeTab === '2' })}
							onClick={() => {
								toggleTab('2');
							}}
						>
							Ejecución
						</NavLink>
					</NavItem>
				</Nav>
			</div>

			<EvidenceForm
				dataActivity={dataActivity}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditEvidenceModal;
